import PropTypes from 'prop-types';
import {
  TwitterShareButton,
  FacebookShareButton,
  TelegramShareButton,
  WhatsappShareButton,
  EmailShareButton,
} from 'react-share';
import { FaFacebookF, FaTelegramPlane, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import { FaXTwitter } from 'react-icons/fa6';

import './MySocialShare.scss';

const propTypes = { title: PropTypes.string.isRequired };
const defaultProps = {};

function MySocialShare({ title }) {
  const url = window.location.href;

  return (
    <div className="mysocialshare__container">
      <TwitterShareButton url={url} title={title}>
        <FaXTwitter className="mysocialshare__icon" />
      </TwitterShareButton>

      <FacebookShareButton url={url} quote={title}>
        <FaFacebookF className="mysocialshare__icon" />
      </FacebookShareButton>

      <TelegramShareButton url={url} title={title}>
        <FaTelegramPlane className="mysocialshare__icon" />
      </TelegramShareButton>

      <WhatsappShareButton url={url} title={title}>
        <FaWhatsapp className="mysocialshare__icon" />
      </WhatsappShareButton>

      <EmailShareButton url={url} subject={title}>
        <FaEnvelope className="mysocialshare__icon" />
      </EmailShareButton>
    </div>
  );
}

MySocialShare.propTypes = propTypes;
MySocialShare.defaultProps = defaultProps;

export default MySocialShare;
